"use strict";
/**
 * Created by cuppi on 2017/7/21.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @member CityModel
 * @property {object}  defaults               - The default values for parties.
 */
var id;
